import createAction from "./utils/createMetaAction";
import createMergedDefaultStateReducer from "./utils/createMergedDefaultStateReducer";
import { noop } from "lodash-es";
export const toggleFindTool = createAction("TOGGLE_FIND_TOOL", noop);
export const toggleHighlightAll = createAction("toggleHighlightAll", noop);
export const toggleMatchReverseComplement = createAction(
  "toggleMatchReverseComplement",
  noop
);
export const toggleIsInline = createAction("toggleIsInline", noop);
export const updateSearchText = createAction("updateSearchText");
export const updateAmbiguousOrLiteral = createAction(
  "updateAmbiguousOrLiteral"
);
export const updateDnaOrAA = createAction("updateDnaOrAA");
export const updateMismatchesAllowed = createAction("updateMismatchesAllowed");
export const updateMatchNumber = createAction("updateMatchNumber");
export default createMergedDefaultStateReducer(
  {
    [toggleFindTool]: (state) => {
      return {
        ...state,
        isOpen: !state.isOpen
      };
    },
    [toggleHighlightAll]: (state) => {
      return {
        ...state,
        highlightAll: !state.highlightAll
      };
    },
    [toggleMatchReverseComplement]: (state) => {
      return {
        ...state,
        matchReverseComplement: !state.matchReverseComplement
      };
    },
    [toggleIsInline]: (state) => {
      return {
        ...state,
        isInline: !state.isInline
      };
    },
    [updateAmbiguousOrLiteral]: (state, payload) => {
      return {
        ...state,
        matchNumber: 0,
        ambiguousOrLiteral: payload
      };
    },
    [updateDnaOrAA]: (state, payload) => {
      return {
        ...state,
        matchNumber: 0,
        dnaOrAA: payload
      };
    },
    [updateMismatchesAllowed]: (state, payload) => {
      return {
        ...state,
        matchNumber: 0,
        mismatchesAllowed: payload
      };
    },
    [updateSearchText]: (state, payload) => {
      const isAminoAcid = /[efilpqjoz]/i.test(payload);
      return {
        ...state,
        matchNumber: 0,
        searchText: payload,
        ...isAminoAcid && state.dnaOrAA === "DNA" ? { dnaOrAA: "AA" } : {}
      };
    },
    [updateMatchNumber]: (state, payload) => {
      return {
        ...state,
        matchNumber: payload
      };
    }
  },
  {
    isOpen: false,
    isInline: true,
    searchText: "",
    dnaOrAA: "DNA",
    ambiguousOrLiteral: "AMBIGUOUS",
    highlightAll: false,
    matchReverseComplement: true,
    mismatchesAllowed: 0,
    matchNumber: 0
  }
);
